if (!process.env.VUE_APP_IS_WEB) {
  var MajorityDB = require("../database/models/Majority");
}

import settings from "@/database/settings";
import dates from "@/database/dates";
import strings from "@/database/strings";

import MajorityORM from "@/store/orm-axios/models/Majority";

export default {
  FETCH(agencyId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        // console.log("FETCH", agencyId);
        new MajorityDB()
          .query({
            where: { agency_id: agencyId, deleted: null },
            // agency_id: 0 is for majority "sans vote"
            orWhere: { agency_id: 0 },
          })
          .fetchAll()
          .then(res => {
            MajorityORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MajorityORM.api()
          .FETCH()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  QUERY_FETCH(agencyId, queryParams) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MajorityDB()
          .query({
            where: { agency_id: agencyId, deleted: null },
            // agency_id: 0 is for majority "sans vote"
            orWhere: { agency_id: 0 },
          })
          .query(qb => {
            queryParams.filter.forEach(filter => {
              qb.where(filter.column, "LIKE", "%" + filter.value + "%");
            });
          })
          .orderBy(queryParams.sort.by, queryParams.sort.dir)
          .fetchPage({
            pageSize: settings.itemsPerPage,
            page: queryParams.page,
          })
          .then(res => {
            MajorityORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MajorityORM.api()
          // TODO: add agency_id: 0 for majority "sans vote" in online DB
          .QUERY_FETCH(agencyId, queryParams)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  FETCH_BY_PAGE(agencyId, queryParams, pagination) {
    console.log(pagination);
    queryParams.page = pagination.page;
    queryParams.pageSize = pagination.pageSize;
    queryParams.itemsPerPage = pagination.pageSize;
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        //  TODO Implement functionality
      });
    } else {
      return new Promise((resolve, reject) => {
        MajorityORM.api()
          .QUERY_FETCH(agencyId, queryParams)
          .then(res => {
            MajorityORM.deleteAll();
            MajorityORM.insertOrUpdate({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MajorityDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            let data = res.serialize();
            MajorityORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MajorityORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));
      itemPost.slug = strings.get_slug(itemPost.name);
      return new Promise((resolve, reject) => {
        new MajorityDB(itemPost)
          .save()
          .then(res => {
            let data = res.serialize();
            MajorityORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MajorityORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      itemPut.slug = strings.get_slug(itemPut.name);
      return new Promise((resolve, reject) => {
        new MajorityDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            var data = res.serialize();
            MajorityORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MajorityORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new MajorityDB(itemPut)
          .save(null, { isDelete: true })
          .then(res => {
            MajorityORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MajorityORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  REGISTER_GET_MAJORITIES(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MajorityORM.api()
          .REGISTER_GET_MAJORITIES(meetingId)
          .then(res => {
            MajorityORM.create({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  CUSTOM_UPDATE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MajorityORM.api()
          .CUSTOM_UPDATE(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
